import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataPriceListForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkDataPriceList = ({
  editable = true,
  linkDataPriceList,
  linkPriceMetadata,
  forceValidation,
  linkPriceListChange,
  linkPriceListValidate,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.priceList.title')}</h3>
    <LinkDataPriceListForm
      editable={editable}
      forceValidation={forceValidation}
      linkPriceList={linkDataPriceList}
      linkPriceMetadata={linkPriceMetadata}
      onChange={linkPriceListChange}
      onValidate={linkPriceListValidate}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsLinkDataPriceList;
